import {Pipe, PipeTransform} from '@angular/core';
import {format} from 'date-fns';

@Pipe({
	name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {
	transform(value: string | undefined): string {
		if (!value) {
			return '';
		}

    const [hours, minutes, seconds] = value.split(':').map(Number);
		const date: Date = new Date();
    date.setHours(hours, minutes, seconds);
		return `${format(date, 'h:mm a')}`;
	}
}
